import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import {
  baseUrl,
  customHeaders,
  ksaProjectsBaseURL,
  thriweMarketPlacePhillipinesUrl,
  thriweMarketPlaceUaeUrl,
  thriweMarketPlaceUrl,
  uaeProjectsBaseURL,
} from '../../../../Containers/Config/index.js';
import { DOWNLOAD_LIST_V2, DOWNLOAD_LIST_V2_SUCCESS, DOWNLOAD_LIST_V2_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getDownloadListV2({ payload }) {
  try {
    const isUaeProject = [
      'HSBC_BEACH_CLUB',
      'ENBD_NATIONAL_DAY',
      'MASTERCARD_FAB',
      'CBD_GOLF_V2',
      'VISA_PVT',
      'MASTERCARD_UAE',
      'MASHREQ',
      'EIB_V2',
    ].includes(Constant.PROJECT_CODE);
    const baseUrl = isUaeProject
      ? thriweMarketPlaceUaeUrl
      : ['HSBC_BENEFITS'].includes(Constant.PROJECT_CODE)
        ? thriweMarketPlacePhillipinesUrl
        : thriweMarketPlaceUrl;

    // Determine the user type (client or admin) based on clientType
    const userType = Constant.userTypes.CLIENT === Number(localStorage.getItem('userType')) ? 'client' : 'admin';

    // Construct the full URL dynamically using template literals
    const downloadListUrl = `${baseUrl}/v1/${userType}/downloads`;

    const response = yield call(apiCall, {
      url: downloadListUrl,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: DOWNLOAD_LIST_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: DOWNLOAD_LIST_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_LIST_V2_ERROR, payload: error });
  }
}

export function* watchDownloadsListV2() {
  yield takeEvery(DOWNLOAD_LIST_V2, getDownloadListV2);
}

function* downloadsListV2Saga() {
  yield all([fork(watchDownloadsListV2)]);
}

export default downloadsListV2Saga;
